import frontPage from './front-page';
import singleInductee from './SingleInductee//single-inductee';
import singleEvent from './single-event';
import singleExhibit from './single-exhibit';
import singleDigitalExhibit from './single-digital-exhibit';
import Ceremony from './single-ceremony';
import InducteeLanding from './page-inductees';
import PressRelease from './single-press-release';
import PressReleasePage from './page-press-releases';
import CoverStoryLanding from './page-cover-story';
import CoverStory from './single-cover-story';
import page from './page';
import single from './single';
import SearchPage from './page-search';
import RockHallTV from './page-rock-hall-tv';
import RockHallTVChannelPreview from './single-rhtv-channel';
import eventsPage from './page-events';

export default {
  'front-page': frontPage,
  'template-Homepage': frontPage,
  'single-inductee': singleInductee,
  'single-event': singleEvent,
  'single-exhibit': singleExhibit,
  'single-digital-exhibit': singleDigitalExhibit,
  'single-ceremony': Ceremony,
  'single-press-release': PressRelease,
  'single-cover-story': CoverStory,
  'single-rhtv-channel': RockHallTVChannelPreview,
  'template-Inductees Landing Page': InducteeLanding,
  'template-Search Page': SearchPage,
  'template-Rock Hall TV': RockHallTV,
  'template-Press Release Landing': PressReleasePage,
  'template-Cover Story Landing Page': CoverStoryLanding,
  'template-Events Landing Page': eventsPage,
  'page-events': eventsPage,
  page,
  single,
};
